export default "__VITE_ASSET__Bn1dFKp0__"